import React, { useState } from "react";
import {
  Button,
  Card,
  DatePicker,
  InputNumber,
  Table,
  Row,
  Col,
  Select,
  Typography,
  Divider,Empty,ConfigProvider
} from "antd";
import { useNavigate } from "react-router-dom";
import EmptyData from '../Assets/EmptyData.jpg';
const { Option } = Select;
const { Text } = Typography;

const initialData = [
  { key: "01", rawmaterial: "Rice", uom: "Kg", poqty: 500, issuedsofar: 120, remaining: 380, issuetoday: 0 },
  { key: "02", rawmaterial: "Wheat", uom: "Kg", poqty: 350, issuedsofar: 50, remaining: 300, issuetoday: 0 },
  { key: "03", rawmaterial: "Oil", uom: "Kg", poqty: 40, issuedsofar: 0, remaining: 40, issuetoday: 0 },
  { key: "04", rawmaterial: "Sugar", uom: "Kg", poqty: 120, issuedsofar: 0, remaining: 120, issuetoday: 0 },
  { key: "05", rawmaterial: "Vitamin", uom: "Kg", poqty: 5, issuedsofar: 0, remaining: 5, issuetoday: 0 },
];

const JW_DC = () => {
  const navigate = useNavigate();
  const [dataSource, setDataSource] = useState(initialData);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const handleIssueTodayChange = (key, value) => {
    const updated = dataSource.map((item) =>
      item.key === key ? { ...item, issuetoday: value || 0 } : item
    );
    setDataSource(updated);
  };

  const columns = [
    { title: "Raw Material", dataIndex: "rawmaterial", key: "rawmaterial" },
    { title: "UOM", dataIndex: "uom", key: "uom" },
    { title: "PO Qty", dataIndex: "poqty", key: "poqty" },
    { title: "Issued so Far", dataIndex: "issuedsofar", key: "issuedsofar" },
    { title: "Remaining", dataIndex: "remaining", key: "remaining" },
    {
      title: "Issue Today",
      dataIndex: "issuetoday",
      key: "issuetoday",
      render: (_, record) => (
        <InputNumber
          min={0}
          value={record.issuetoday}
          onChange={(value) => handleIssueTodayChange(record.key, value)}
        />
      ),
    },
  ];

  const rowSelection = {
    selectedRowKeys,
    onChange: (newKeys) => setSelectedRowKeys(newKeys),
  };

  return (
     <Card style={{ margin: 24 }}>
        
        <Row justify="space-between" align="middle" style={{ marginBottom: 16 }}>
          <Col>
                    <Text strong style={{ fontSize: 16,columnGap:20 }}>Delivery Challan — Jobwork Issue</Text>
                    <br />
                    <Text type="secondary" style={{ fontSize: 12,border:"1px  solid",borderRadius:"5px" }}>
                      MSPC: KARWAR • Month: Aug 2025 • PO: JWPO-202508-123
                    </Text>
                  </Col>
          <Col>
           <span style={{ fontWeight: 400 }}>MSPC: </span>
            <Select defaultValue="KARWAR" style={{ width: 120, marginRight: 10 }}>
              <Option value="KARWAR">KARWAR</Option>
            </Select>
             <span style={{ fontWeight: 400 }}>Month: </span>
            <Select defaultValue="Aug 2025" style={{ width: 120, marginRight: 10 }}>
              <Option value="Aug 2025">Aug 2025</Option>
            </Select>
            <Button style={{ marginRight: 8 }}>Load POs</Button>
            <Button>Load Draft</Button>
             <Col>
            <Button type="default" style={{ marginLeft:45,marginTop:10 }}>Save Draft</Button>
        </Col>
          </Col>
        </Row>
      {/* Step Buttons */}
      <Divider />
      <Row gutter={12} justify="space-between" style={{ marginBottom: 16 }}>
        <Col>
          <Button type="primary">1. Select PO & RM</Button>
        </Col>
        <Col>
          <Button>2. Pack & Weigh (Bags)</Button>
        </Col>
        <Col>
          <Button>3. Transport</Button>
        </Col>
        <Col>
          <Button>4. Review & Generate</Button>
        </Col>
      </Row>

     
    <Row
  justify="space-between"
  align="middle"
  style={{ marginBottom: 16, flexWrap: "nowrap" }}
>
  <Col flex="auto">
    <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
      <Text strong style={{ fontSize: 14 }}>
        Step 1 — Choose Jobwork PO and Select Raw Materials to Issue
      </Text>
      <label style={{ fontWeight: 500 }}>Jobwork PO:</label>
      <Select
        defaultValue="JWPO-202508-123"
        style={{ minWidth: 400 }}
        size="middle"
      >
        <Option value="JWPO-202508-123">
          JWPO-202508-123 • KARWAR • Aug 2025 • Sri Annapurna Millers
        </Option>
      </Select>
    </div>
  </Col>

  <Col>
    <Button type="default">Fill Remaining</Button>
  </Col>
</Row>


      <ConfigProvider
                    renderEmpty={() => (
                      <Empty
                        image={EmptyData}
                        description="No CategoryMaster Data Available"
                        imageStyle={{ height: 200 }}
                      />
                    )}
                  >
      <Table
        bordered
        dataSource={dataSource}
        columns={columns}
        pagination={false}
        rowSelection={rowSelection}
        summary={(pageData) => {
          let totalPO = 0,
            totalIssued = 0,
            totalRemaining = 0,
            totalIssuedToday = 0;

          pageData.forEach(({ poqty, issuedsofar, remaining, issuetoday }) => {
            totalPO += poqty;
            totalIssued += issuedsofar;
            totalRemaining += remaining;
            totalIssuedToday += issuetoday;
          });

          return (
            <Table.Summary.Row>
              <Table.Summary.Cell index={0} />
              <Table.Summary.Cell index={1} />
              <Table.Summary.Cell index={2}><b>Totals (selected)</b></Table.Summary.Cell>
              <Table.Summary.Cell index={3}><b>{totalPO}</b></Table.Summary.Cell>
              <Table.Summary.Cell index={4}><b>{totalIssued}</b></Table.Summary.Cell>
              <Table.Summary.Cell index={5}><b>{totalRemaining}</b></Table.Summary.Cell>
              <Table.Summary.Cell index={6}><b>{totalIssuedToday}</b></Table.Summary.Cell>
            </Table.Summary.Row>
          );
        }}
      />
      </ConfigProvider>

      <Row justify="end" style={{ marginTop: 24 }}>
        <Button type="primary" onClick={() => navigate('/jobwork/jobwork_dc/jw_transportdc')}>Next Pack & weight</Button>
      </Row>
    </Card>
  );
};

export default JW_DC;
